<template>
  <div class="kws-int-form-date-picker form-row" ref="calendar">
    <div class="floating-input-label">
      <span class="s s-date" @click="openCalendar"></span>
      <input type="text" class="floating-input-label__input"
             ref="input"
             v-model="text"
             placeholder=" "
             @click="openCalendar"
             @keyup.prevent="parseDate"
             @change="confirmInput"
      >
      <label class="floating-input-label__label" v-text="label"></label>
    </div>
    <div v-if="isOpen" class="calendar">
      <div class="month-selection">
        <span class="prev s s-slider-left" @click="goToPreviousMonth"></span>
        <span class="month" v-text="title"></span>
        <span class="next s s-slider-right" @click="goToNextMonth"></span>
      </div>
      <div class="tables tables-top">
        <table>
          <thead>
            <tr>
              <td v-for="weekday in weekdays" :key="weekday" v-text="weekday"></td>
            </tr>
          </thead>
        </table>
      </div>
      <div class="tables tables-bottom">
        <table>
          <tbody>
          <tr v-for="(week, index) in weeks" :key="index">
            <td v-for="day in week"
                :key="day.label"
                v-text="day.label"
                :class="{
                  'out-of-range': !day.isSelectedMonth,
                  today: day.isToday,
                  event: day.isSelectedDate,
                }"
                @click="pick(day)"
            ></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="actions">
        <span class="cancel" @click="closeCalendar" v-text="translate('lblCancel')"></span>
        <span class="ok" @click="confirmSelection" v-text="translate('lblConfirm')"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    text: '',
    title: null,
    isOpen: false,
    pickingDate: null,
    weeks: null,
    weekdays: window.moment.weekdaysShort(true),
  }),
  props: {
    date: Date,
    label: String,
    format: {
      type: String,
      default: 'DD.MM.YYYY',
    },
  },
  methods: {
    setErrorTo(error) {
      this.$refs.input.setCustomValidity(
        error ? this.translate('lblInvalidDate', { format: this.format }) : '',
      );
      this.$refs.input.reportValidity();
    },
    parseDate() {
      if (this.text !== '') {
        this.setErrorTo(false);
        const m = window.moment(this.text, `${this.format} 0:00`);
        if (m.isValid()) {
          this.pickingDate = m;
          this.rerender();
        } else {
          this.setErrorTo(true);
        }
      }
    },
    confirmInput() {
      const m = window.moment(this.text, `${this.format} 0:00`);

      this.pickingDate = m.isValid() ? m : null;

      this.confirmSelection();
    },
    openCalendar() {
      const m = window.moment(this.text, `${this.format} 0:00`);
      if (m.isValid()) {
        this.pickingDate = m;
      } else {
        this.pickingDate = window.moment();
      }
      this.rerender();
      this.isOpen = true;
    },
    closeCalendar() {
      this.isOpen = false;
    },
    pick(day) {
      this.pickingDate = day.date;
      // wait for `handleClickOutside` check
      setTimeout(this.rerender, 50);
    },
    confirmSelection() {
      this.text = (this.pickingDate) ? this.pickingDate.format(this.format) : '';
      this.setErrorTo(false);
      this.$emit('change', this.pickingDate?.toDate());
      this.closeCalendar();
    },
    getWeeksForPickingDate() {
      const now = window.moment();
      const startDate = window.moment(this.pickingDate).startOf('month').startOf('week');
      startDate.day(1).hour(0);

      const endDate = window.moment(this.pickingDate).endOf('month');
      if (endDate.day() !== 0) {
        endDate.day(7);
      }
      const currentDate = window.moment(startDate);
      const weeks = [];
      let week = [];
      while (currentDate.diff(endDate) < 0) {
        week.push({
          date: window.moment(currentDate),
          label: window.moment(currentDate).format('D'),
          isSelectedMonth: currentDate.month() === this.pickingDate.month(),
          isSelectedDate: currentDate.format(this.format) === this.pickingDate.format(this.format),
          isToday: currentDate.format(this.format) === now.format(this.format),
        });
        currentDate.add(1, 'days');
        if (currentDate.day() === 1) {
          weeks.push(week);
          week = [];
        }
      }
      return weeks;
    },
    goToPreviousMonth() {
      this.pickingDate.subtract(1, 'months');
      this.rerender();
    },
    goToNextMonth() {
      this.pickingDate.add(1, 'months');
      this.rerender();
    },
    rerender() {
      this.title = this.pickingDate.format('MMMM YYYY');
      this.weeks = this.getWeeksForPickingDate();
      this.$forceUpdate();
    },
    observeClicksOutside() {
      const handleClickOutside = (e) => {
        if (this.$refs
          && this.$refs.calendar
          && e.target !== this.$refs.calendar
          && !this.$refs.calendar.contains(e.target)
        ) {
          this.closeCalendar();
        }
      };
      document.body.addEventListener('click', handleClickOutside);
    },
  },
  created() {
    this.text = (this.date) ? window.moment(this.date).format(this.format) : '';
  },
  mounted() {
    this.observeClicksOutside();
  },
};
</script>

<style lang="scss">
.kws-int-form-date-picker {
  input.floating-input-label__input {
    padding-right: rem(35px) !important;
  }
  .calendar {
    right: 0;
  }
}
</style>
